import { styled, Theme } from "@mui/material";

export const layoutDrawerStyle = () => ({
  position: "relative",
  height: "100%",
  display: "flex",
  flexDirection: "column",
});

export const layoutDrawerInnerStyle = (theme: Theme) => ({
  padding: "16px 40px 10px",
  [theme.breakpoints.down("sm")]: {
    padding: "24px",
  },
});

export const Image = styled("img")(({ theme }) => ({
  height: "270px",
  background: "#e8dfd855",
  objectFit: "cover",
  width: "100%",
}));

export const ImageOverlay = styled("div")(({ theme }) => ({
  height: "270px",
  background: "#e8dfd855",
  width: "100%",
  display: "grid",
  alignItems: "center",
}));
